export default __webpack_public_path__ + "media/images/theme/wordmark_dark_backup-00b1192a59c00c70201dc8ef0d792abc.png";